import { hotComics, formatViewsHelper } from "./heroData";

export default function Hero() {
  const top = hotComics.slice(0, 3);
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cozy%20cat%20comic%20hero%20scene%20with%20several%20adorable%20cats%20surrounded%20by%20floating%20comic%20panels%20and%20hearts%2C%20soft%20cream%20peach%20and%20orange%20illustration%2C%20playful%20flat%20art%2C%20gentle%20warm%20lighting%2C%20whimsical%20and%20heartwarming%20atmosphere&width=1600&height=900&seq=hero-cat-comic-01&orientation=landscape"
        alt="喵趣漫画养猫日常漫画背景图"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative w-full max-w-4xl mx-auto px-4 md:px-6 text-center text-background-50">
        <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 backdrop-blur border border-background-50/30 text-sm px-4 py-1.5 mb-5">
          <i className="ri-sparkling-line"></i>
          喵趣漫画 · 轻松日常持续更新
        </p>
        <h1 className="font-heading text-4xl md:text-6xl leading-tight drop-shadow">
          养猫人的日常漫画
          <span className="block mt-1 text-accent-500">都在这里</span>
        </h1>
        <p className="mt-5 max-w-2xl mx-auto text-sm md:text-base leading-relaxed text-background-50/90">
          喵趣漫画汇集喵趣漫画日常、喵趣漫画养猫日常、喵趣漫画生活日常与日常趣事等作品。从橘猫的饭量之谜到午夜跑酷现场，每一帧都是铲屎官的真实快乐，随时随地在线看。
        </p>
        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => window.REACT_APP_NAVIGATE("/category")}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm px-8 py-3 whitespace-nowrap transition-colors cursor-pointer"
          >
            立即开始看漫画
            <i className="ri-arrow-right-line"></i>
          </button>
          <button
            onClick={() => window.REACT_APP_NAVIGATE("/about")}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-background-50/15 backdrop-blur border border-background-50/40 text-background-50 text-sm px-8 py-3 whitespace-nowrap hover:bg-background-50/25 transition-colors cursor-pointer"
          >
            了解喵趣
          </button>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 md:gap-10 flex-wrap">
          {top.map((c) => (
            <button
              key={c.id}
              onClick={() => window.REACT_APP_NAVIGATE(`/comic/${c.id}`)}
              className="flex items-center gap-3 text-left group cursor-pointer"
            >
              <img
                src={c.cover}
                alt={`${c.title} 封面`}
                className="w-12 h-16 rounded-lg object-cover ring-2 ring-background-50/40"
              />
              <span>
                <span className="block text-sm font-medium group-hover:text-accent-500">
                  {c.title}
                </span>
                <span className="block text-xs text-background-50/75 mt-0.5">
                  {c.category} · {formatViewsHelper(c.views)}
                </span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}